var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewPaquetesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 84,
    viewBox: "0 0 92 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6667 42C35.3654 42 33.5 43.8654 33.5 46.1666C33.5 48.4679 35.3654 50.3333 37.6667 50.3333H54.3333C56.6344 50.3333 58.5 48.4679 58.5 46.1666C58.5 43.8654 56.6344 42 54.3333 42H37.6667Z",
    fill: "#1A3D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 0.333313C5.76308 0.333313 0.166664 5.92973 0.166664 12.8333V71.1666C0.166664 78.0702 5.76308 83.6666 12.6667 83.6666H79.3333C86.2369 83.6666 91.8333 78.0702 91.8333 71.1666V12.8333C91.8333 5.92973 86.2369 0.333313 79.3333 0.333313H12.6667ZM79.3333 8.66665H12.6667C10.3654 8.66665 8.5 10.532 8.5 12.8333V25.3333H83.5V12.8333C83.5 10.532 81.6344 8.66665 79.3333 8.66665ZM8.5 71.1666V33.6666H83.5V71.1666C83.5 73.4679 81.6344 75.3333 79.3333 75.3333H12.6667C10.3654 75.3333 8.5 73.4679 8.5 71.1666Z",
    fill: "#1A3D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPaquetesIcon);
export default __webpack_public_path__ + "static/media/newPaquetesIcon.6bc0d25d0f8f858fc4852c6778b3dd4d.svg";
export { ForwardRef as ReactComponent };